import FontAwesomeIcon from 'src/components/Icon';
import Avatar from 'src/components/Avatar';
import Tenant from 'src/components/Tenant';
import { ITableColumn } from 'src/components/Table/types';
import { Link } from 'react-router-dom';
import { Hidden } from 'src/components/Table';
import Button from 'src/components/Button';

interface CreateSuiteUsersTableColumnsParams {
  user: any;
  handleSetContactFormData: (contactId: string) => void;
  PATHS: any;
  ICONS: any;
  onRequestPhoneCall: (phone: string) => any;
}

export const createSuiteUsersTableColumns = ({
  user,
  handleSetContactFormData,
  PATHS,
  ICONS,
  onRequestPhoneCall,
}: CreateSuiteUsersTableColumnsParams): ITableColumn[] => {
  return [
    {
      label: 'Contact',
      sortable: true,
      accessor: 'firstname',
      cell: (data) => {
        let type = data.role;
        return (
          <Link
            style={{
              cursor:
                user.roles[0].role.name === 'Admin' ||
                user.roles[0].role.name === 'Property Developer'
                  ? 'pointer'
                  : 'auto',
            }}
            to={
              user.roles[0].role.name === 'Admin' ||
              user.roles[0].role.name === 'Property Developer'
                ? {
                    pathname: PATHS.CONTACTS_VIEW.replace(':id', data.id),
                    state: {
                      data: data,
                    },
                  }
                : {}
            }
          >
            <Tenant
              headline={`${data.firstname} ${data.lastname}`}
              avatar={<Avatar badge={ICONS[type]} url={data.profileImage} />}
            />
          </Link>
        );
      },
    },
    {
      xsHide: true,
      label: 'Role',
      accessor: 'roles[0].role.name',
      cell: (data) => {
        let type = data.roles[0].role.name;
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div>{type}</div>
            {data.contactType ? (
              <div style={{ paddingLeft: 3 }}>{'- ' + data.contactType} </div>
            ) : null}
            {data.isPrimaryContact === true ? (
              <div
                style={{
                  display: 'flex',
                  color: '#48C2BF',
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingLeft: 5,
                }}
              >
                <FontAwesomeIcon glyph="sun" weight="regular" size="small" />
              </div>
            ) : (
              <div />
            )}
          </div>
        );
      },
    },
    {
      label: 'Phone',
      accessor: 'phone',
      cell: (data) => onRequestPhoneCall(data.phone),
    },
    {
      xsHide: true,
      label: 'Email',
      accessor: 'email',
    },
    {
      cell: (data) => (
        <Hidden>
          {user.roles[0].role.name === 'Admin' ||
          user.roles[0].role.name === 'Super Admin' ||
          user.roles[0].role.name === 'Property Developer' ? (
            <Button
              color="semantic"
              label={<FontAwesomeIcon glyph="pencil" weight="light" />}
              onClick={() => handleSetContactFormData(data.id)}
            />
          ) : null}
        </Hidden>
      ),
    },
  ];
};
